import React, { ReactElement } from 'react';
import { SUGGESTION_TYPE } from 'b2b-apps/shop/app/components/App/Header/Autosuggest';
import { InkFinderLink, LABEL_TYPE } from 'b2b-apps/shop/common/components/InkFinderLink';
import { Categories } from './Categories';
import { Products } from './Products';
import { SearchSuggestions } from './SearchSuggestions';
import { ComponentType, Props } from './';
import 'b2b-apps/shop/app/components/App/Header/Autosuggest/Autosuggest/Autosuggest.scss';

const INKFINDERLINK_KEYWORDS = ['tinte', 'toner', 'ink', 'drucker', 'druckertinte'];

export const Autosuggest: ComponentType = ({
  activeItem,
  autosuggestRefCallback,
  getCategoryUrl,
  getProductUrl,
  getSearchSuggestionUrl,
  isAutosuggestOpened,
  onAutosuggestContentClick,
  onCategoryClick,
  onInkFinderClick,
  onMouseEnter,
  onProductClick,
  onSearchSuggestionClick,
  suggestions,
}: Props): ReactElement | null => {
  const { data } = suggestions;

  if (
    !isAutosuggestOpened
    || !data
    || ((!Array.isArray(data.facets.facet) || data.facets.facet.length === 0)
      && (!Array.isArray(data.suggestions) || data.suggestions.length === 0)
      && (!Array.isArray(data.products) || data.products.length === 0))
  ) {
    return null;
  }

  const isInkFinderLinkDisplayed = INKFINDERLINK_KEYWORDS.includes(data?.term);

  return (
    <div className="Autosuggest" data-test="autosuggest">
      <div className="container Autosuggest-Container">
        <div
          className="Autosuggest-Content"
          onClick={onAutosuggestContentClick}
          ref={autosuggestRefCallback}
          data-test="autosuggestContent"
        >
          <div className="Autosuggest-Suggestions">
            <Categories
              activeItemIndex={activeItem.type === SUGGESTION_TYPE.category ? activeItem.index : null}
              facets={data.facets}
              getCategoryUrl={getCategoryUrl}
              onCategoryClick={onCategoryClick}
              onMouseEnter={onMouseEnter}
              term={data.term}
            />

            <SearchSuggestions
              activeItemIndex={activeItem.type === SUGGESTION_TYPE.search ? activeItem.index : null}
              getSearchSuggestionUrl={getSearchSuggestionUrl}
              onMouseEnter={onMouseEnter}
              onSearchSuggestionClick={onSearchSuggestionClick}
              suggestions={data.suggestions}
            />
            {isInkFinderLinkDisplayed && (
              <div className="Autosuggest-InkFinderLink" onClick={onInkFinderClick} >
                <InkFinderLink labelType={LABEL_TYPE.long} />
              </div>
            )}
          </div>

          <Products
            activeItemIndex={activeItem.type === SUGGESTION_TYPE.product ? activeItem.index : null}
            getProductUrl={getProductUrl}
            onMouseEnter={onMouseEnter}
            onProductClick={onProductClick}
            products={data.products}
            term={data.term}
          />
        </div>
      </div>
    </div>
  );
};
